import { clearClientCacheAndReturnHome, getRefreshToken, persistTokenResponse } from '../util/auth';

import { refreshTokens } from './auth-api';
import { StorageKey } from '../enum/StorageKey';

let accessToken: string | null = null;

let isRefreshing = false;

let pendingQueue: Array<{
  resolve: (token: string) => void;
  reject: (err: unknown) => void;
}> = [];

export const getAccessToken = (): string | null => accessToken;

export const setAccessToken = (newAccessToken: string): void => {
  accessToken = newAccessToken;
};

const flushQueue = (error: unknown, token: string | null): void => {
  pendingQueue.forEach(({ resolve, reject }) => {
    if (token) {
      resolve(token);
    } else {
      reject(error);
    }
  });

  pendingQueue = [];
};

export const refreshAccessToken = async (): Promise<string> => {
  // If refresh already running, queue behind it.
  if (isRefreshing) {
    return new Promise<string>((resolve, reject) => {
      pendingQueue.push({
        resolve,
        reject,
      });
    });
  }

  isRefreshing = true;

  const refreshToken = getRefreshToken();

  if (!refreshToken) {
    clearClientCacheAndReturnHome();

    isRefreshing = false;

    throw new Error('No refresh token available.');
  }

  try {
    const tokens = await refreshTokens(refreshToken);

    persistTokenResponse(tokens);

    setAccessToken(tokens.access_token);

    flushQueue(null, tokens.access_token);

    return tokens.access_token;
  } catch (err) {
    flushQueue(err, null);

    clearClientCacheAndReturnHome();

    throw err;
  } finally {
    isRefreshing = false;
  }
};

export const hydrateAuth = () => {
  accessToken = localStorage.getItem(StorageKey.ACCESS_TOKEN);
};
